export const banner = () => {
    const $ = jQuery;

    const banner = $('#promo-banner');
    const close = $('#promo-banner-close');
    const type = banner.data('type');

    let cookieData = getCookie('ans_banner');

    if (cookieData === undefined) {
        cookieData = [];
    } else {
        cookieData = JSON.parse(cookieData);
    }

    if (ans.banner === '1' && $.inArray(type, cookieData) === -1) {
        banner.addClass('show');
    }

    close.on('click', (e) => {
        cookieData.push(type);

        document.cookie = "ans_banner=" + JSON.stringify( cookieData ) + "; path=/";

        banner.remove();
    });
};